<template>
  <div>
    <section-header ref="selectHeader" title="Select Location"></section-header>
    <location-selection labeledBy="selectionHeader"></location-selection>
    <app-navigator
      ref="appNavigator"
      :router="$router"
      nextButtonTitle="Select one or more locations to continue"
    ></app-navigator>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import locationSelection from "@/components/locationSelection";
import current from "@/scripts/current";
import commonModelHelper from "@/scripts/commonModelHelper";
import sectionHeader from "@/components/sub/sectionHeader";
import appNavigator from "@/components/layout/appNavigator";

export default {
  components: {
    locationSelection,
    sectionHeader,
    appNavigator,
  },
  data: function () {
    let vm = this;
    current.initializeLogisticRegressionValues(vm);
    commonModelHelper.initializeStep(vm, "location");
    return {};
  },
  methods: {},
};
</script>

<style scoped="">
</style>
